/** @jsxImportSource @emotion/react */
import { Card, Typography, useTheme } from '@quickbit/qb-design-system';
import { JsonDiff } from './JsonDiff';

interface Props {
  record: any;
  previousRecord?: any;
}

export const HistoryDifferenceCard = ({ record, previousRecord }: Props) => {
  const { spacing, palette, shape } = useTheme();

  return (
    <Card>
      <div
        css={{
          display: 'flex',
          justifyContent: 'space-between',
          marginBottom: spacing.xxxs,
        }}
      >
        <div css={{ display: 'flex', gap: spacing.xxxs, alignItems: 'center' }}>
          {/* eslint-disable-next-line @typescript-eslint/no-unsafe-member-access */}
          <Typography>{record.changeReason}</Typography>
          {/* eslint-disable-next-line @typescript-eslint/no-unsafe-member-access */}
          <Typography variant="bodySmallest">{record.changedBy}</Typography>
        </div>
        {/* eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call */}
        <Typography>{record.createdAt.toLocaleString()}</Typography>
      </div>
      {/* eslint-disable-next-line @typescript-eslint/no-unsafe-member-access */}
      {record.comment && (
        <div
          css={{
            display: 'flex',
            gap: spacing.xxxs,
            marginBottom: spacing.xxxs,
          }}
        >
          <Typography variant="bodySmallMedium">Comment:</Typography>
          {/* eslint-disable-next-line @typescript-eslint/no-unsafe-member-access */}
          <Typography variant="bodySmallMedium">{record.comment}</Typography>
        </div>
      )}
      <div
        css={{
          backgroundColor: palette.grey.x100,
          borderRadius: shape.borderRadius,
          padding: spacing.xxxs,
        }}
      >
        <JsonDiff
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          oldObject={previousRecord ? previousRecord.record : {}}
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          newObject={record.record}
        />
      </div>
    </Card>
  );
};
